function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import MUITooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import { arrow, popper, tooltip } from './Tooltip.style';
import { jsx as ___EmotionJSX } from "@emotion/core";

const styles = () => ({
  arrow,
  popper,
  tooltip
});

const Tooltip = (_ref) => {
  let {
    title,
    position,
    children,
    classes
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "position", "children", "classes"]);

  if (!title) {
    return children;
  }

  const [arrowRef, setArrowRef] = React.useState(null);
  const handleArrowRef = useCallback(node => {
    if (node !== null) {
      setArrowRef(node);
    }
  }, []);
  return ___EmotionJSX(MUITooltip, _extends({
    title: ___EmotionJSX(React.Fragment, null, title, ___EmotionJSX("span", {
      className: classes.arrow,
      ref: handleArrowRef
    })),
    classes: {
      tooltip: classes.tooltip,
      popper: classes.popper
    },
    PopperProps: {
      style: {
        position: 'absolute',
        inset: '0 auto auto 0'
      },
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    },
    placement: position
  }, props), children);
};

Tooltip.defaultProps = {
  position: 'top'
};
Tooltip.propTypes = {
  /** The content of the tooltip description */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  children: PropTypes.node.isRequired,

  /** Position of the tooltip in relation to the wrapped element */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /** Classes for specifying custom styling for 'arrow', 'popper' and 'tooltip */
  classes: PropTypes.shape({
    arrow: PropTypes.string.isRequired,
    popper: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired
  }).isRequired
};
export default React.memo(withStyles(styles)(Tooltip));
//# sourceMappingURL=Tooltip.js.map